/**
 * streamPost — POSTs JSON and consumes a text/event-stream response. Calls
 * `onEvent({ type, ... })` for each `data: <json>` payload. Resolves when the
 * stream ends.
 */
export async function streamPost(url, body, onEvent) {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf('\n\n')) !== -1) {
      const raw = buf.slice(0, idx).trim();
      buf = buf.slice(idx + 2);
      if (!raw.startsWith('data:')) continue;
      const json = raw.slice(5).trim();
      try { onEvent(JSON.parse(json)); } catch { /* ignore parse errors */ }
    }
  }
}
